import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IPropertyDetailDTO} from "../../types/property/IPropertyDetailDTO";
import {getPropertyCardDetailOverviewLocationLabel} from "../../utils/get_property_card_detail_overview_location_label";

import * as styles from "./HomematchPropertyCardDetailOverviewLocation.module.css";

interface IProps {
    property: IPropertyDetailDTO;
}

export const HomematchPropertyCardDetailOverviewLocation = (props: IProps) => {
    const {property} = props;

    const offer = property.offer;
    const developerName = offer.investor ?? offer.vendor.name;
    const locationLabel = getPropertyCardDetailOverviewLocationLabel(offer.address);
    const locationLine = `${locationLabel} | ${developerName}`;

    return (
        <div className={styles.locationRow}>
            <MapMarkerOutlineIcon className={styles.locationIcon} size="2" wrapperSize="2" />

            <Text className={styles.locationText} variant="info_txt_2">
                {locationLine}
            </Text>
        </div>
    );
};
import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IPropertyDetailDTO} from "../../types/property/IPropertyDetailDTO";
import {getPropertyCardDetailOverviewLocationLabel} from "../../utils/get_property_card_detail_overview_location_label";

import * as styles from "./HomematchPropertyCardDetailOverviewLocation.module.css";

interface IProps {
    property: IPropertyDetailDTO;
}

export const HomematchPropertyCardDetailOverviewLocation = (props: IProps) => {
    const {property} = props;

    const offer = property.offer;
    const developerName = offer.investor ?? offer.vendor.name;
    const locationLabel = getPropertyCardDetailOverviewLocationLabel(offer.address);
    const locationLine = `${locationLabel} | ${developerName}`;

    return (
        <div className={styles.locationRow}>
            <MapMarkerOutlineIcon className={styles.locationIcon} size="2" wrapperSize="2" />

            <Text className={styles.locationText} variant="info_txt_2">
                {locationLine}
            </Text>
        </div>
    );
};
